import React, { useState } from "react";
import CustomModal from "../Common/CustomModal";
import { Box, Typography } from "@mui/material";
import { CustomInput } from "../Common/CustomInput";
import { colors } from "../../theme/theme";
import { TitleSharp } from "@mui/icons-material";
import { CustomBtn } from "../Common/CustomBtn";
import ImageUploadInput from "../Common/ImageUploadInput";
import { dataURItoBlob } from "../../utils/services/ImageUpload";
import axiosInstance from "../../utils/config/config";

const CreateDocumentModal = ({ open, onClose, onCreated, setErrorState }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [cover, setCover] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileUrl, setFileUrl] = useState(null);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;
    setFileName(selected.name);
    dataURItoBlob(selected, setFileUrl);
  };

  const handleSave = async () => {
    if (!title || !description || !fileName) {
      setErrorState({
        error: true,
        errorMsg: "Please fill all the fields",
      });
      return;
    }

    try {
      await axiosInstance.post("/document/createDocument", {
        title,
        description,
        cover_url: cover,
        file_url: fileUrl,
        file_name: fileName,
      });

      setTitle("");
      setDescription("");
      setCover(null);
      setFileName("");
      setFileUrl(null);
      onClose();
      onCreated?.();
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.response?.data?.message || "Failed to add document",
      });
    }
  };

  return (
    <CustomModal open={open} onClose={onClose} title="Add Document">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
          margin: "0 auto",
        }}
      >
        <CustomInput
          label={"Document Title"}
          value={title}
          handleChange={(e) => setTitle(e.target.value)}
          placeholder={"Enter document title"}
          Icon={TitleSharp}
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
        />
        <CustomInput
          label={"Document Description"}
          value={description}
          handleChange={(e) => setDescription(e.target.value)}
          placeholder={"Enter document description"}
          noIcon
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
          textArea
        />

        <ImageUploadInput
          image={cover}
          setImage={setCover}
          width={"90%"}
          label={"Cover Image (optional)"}
        />

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            mt: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Mulish-Regular",
              fontSize: "12px",
              color: colors.textColor,
              fontWeight: "700",
              mb: 0.5,
              textTransform: "uppercase",
            }}
          >
            File
          </Typography>
          <input
            type="file"
            onChange={handleFileChange}
            style={{ fontFamily: "Mulish-Regular", fontSize: "13px" }}
          />
        </Box>

        <CustomBtn
          text={"Save"}
          width={"100%"}
          height={"50px"}
          mt={3}
          mb={2}
          onClick={handleSave}
        />
      </Box>
    </CustomModal>
  );
};

export default CreateDocumentModal;
